import { stringFromJSONValue } from './parser'

export class AgencySearchItemModel {
  public agencyRecordID: string
  public agencyID: string
  public display1: string
  public display2: string

  public constructor(agencyRecordID: string, agencyID: string, display1: string, display2: string) {
    this.agencyRecordID = agencyRecordID
    this.agencyID = agencyID
    this.display1 = display1
    this.display2 = display2
  }

  public static modelFromJSON(json: any): AgencySearchItemModel {
    return new AgencySearchItemModel(
      stringFromJSONValue(json['id']),
      stringFromJSONValue(json['agencyid']),
      stringFromJSONValue(json['Display1']).trim(),
      stringFromJSONValue(json['Display2']).trim()
    )
  }

  public truncatedDisplay2() {
    if (this.display2.length <= 100) {
      return this.display2
    }
    return this.display2.substring(0, 97).concat('...')
  }
}
